import { format } from "date-fns";

import { HQ_WORKFORCE_SERVICE, mockPath } from "constants/app";
import { DateFormats } from "helpers/dates";
import { getRequest, checkStatus, parseStatusAndBody } from "helpers/requests";
import {
  ISalesForecastResponse,
  salesForecastToNumbers,
} from "helpers/transforms/account";
import { ISalesForecast } from "types/account";

const MOCK_FORECASTED = `/forecastedSales`;

function getSalesForecast(
  permalink: string,
  storePrettyUrl: string,
  startDate: Date,
  endDate: Date
): Promise<ISalesForecast> {
  const forecastPath = mockPath(
    `${HQ_WORKFORCE_SERVICE}/${permalink}/insights/labor/forecasted_sales`,
    MOCK_FORECASTED
  );
  const [startDateParam, endDateParam] = [startDate, endDate].map((date) =>
    encodeURIComponent(format(date, DateFormats.YEAR_MONTH_DAY))
  );
  return fetch(
    `${forecastPath}?store_pretty_url=${encodeURIComponent(
      storePrettyUrl
    )}&start_date=${startDateParam}&end_date=${endDateParam}`,
    getRequest()
  )
    .then((response) => parseStatusAndBody<ISalesForecastResponse>(response))
    .then((parsedResponse: [number, ISalesForecastResponse]) =>
      checkStatus<ISalesForecastResponse>(parsedResponse)
    )
    .then(salesForecastToNumbers);
}

export { getSalesForecast };
